import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { VacationRequest } from '@/openapi';
import { ScheduleConfigService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useCreateVacationRequestMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vacationRequest: VacationRequest) => {
      return ScheduleConfigService.scheduleConfigServiceCreateVacationRequest({
        body: vacationRequest,
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.schedule.vacationRequests(),
        }),
        queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all }),
      ]);
    },
  });
};
